import { render, staticRenderFns } from "./moveSearch.vue?vue&type=template&id=0361178a&"
import script from "./moveSearch.vue?vue&type=script&lang=js&"
export * from "./moveSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports